// extracted by mini-css-extract-plugin
export default {"headerStatisticContainer":"HeaderStatistic_headerStatisticContainer__GZADy"};